// @ts-expect-error: Flow to TS migration.
import { createBrowserHistory, createMemoryHistory } from "history"
// @ts-expect-error: Flow to TS migration.
import type { RouterHistory } from "react-router-dom"

const isNotBrowser =
  typeof window === "undefined" ||
  // in jest tests there is window defined even for non-browser tests
  process.env.NODE_ENV === "test"

const browserHistory: RouterHistory = isNotBrowser ? createMemoryHistory() : createBrowserHistory()

export default browserHistory
